import { createCn } from 'shared-utils'

export const articleSizedBoxesCn = createCn('article-sized-boxes')
